import request from "services/Request"


export function login(data) {
	return request({
		url: `/shop/customers/token`,
		method: 'POST',
		data
	}, data => data)
}

export function clientToken(id: number) {
	return request({
		url: `/shop/clients/refresh-token`,
		method: 'POST',
		data: { clientId: id }
	}, data => data)
}

export function refreshToken(data) {
	return request({
		url: `/shop/authentication-token/refresh`,
		method: 'POST',
		data
	}, data => data)
}

export function requestPasswordReset(data) {
	return request({
		url: `/shop/customers/reset-password`,
		method: 'POST',
		data
	}, data => data)
}

export function passwordReset(token: string, data) {
	return request({
		url: `/shop/customers/reset-password/${token}`,
		method: 'PATCH',
		headers: { 'content-type': 'application/merge-patch+json' },
		data
	}, data => data)
}
